module.exports = __webpack_public_path__ + "img/Really.9130c154.svg";